import { useState } from 'react';
import { handleRequestHelper } from '../../../utils/helpers';
import api from '../../../api/api';
import { NOTIFICATION_VARIANT, USER_PERMISSIONS } from '../../../constants/types';
import { useNotifications } from '../../../Providers/NotificationsProvider/NotificationsProvider';
import { useAuth } from '../../../Providers/AuthProvider/AuthProvider';
import { getUrlSearchParams, validateUserRole } from '../../../utils/utils';

export const useMarketplaceAuthenticationPage = () => {
  const { code } = getUrlSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const [marketplaceSuccessCreated, setMarketplaceSuccessCreated] = useState(false);

  const { user } = useAuth();
  const isUserLogged = !!user;
  const userIsAdmin = validateUserRole(user?.role, USER_PERMISSIONS.ADMIN);

  const { showNotification } = useNotifications();

  const handleMarketplaceOauth = async () => {
    if (!code || !accountId) return;

    setIsLoading(true);
    await handleRequestHelper({
      endpoint: () => api.marketplaceOauth(code, accountId),
      onSuccess: () => {
        showNotification('La cuenta fue autenticada con éxito.', NOTIFICATION_VARIANT.SUCCESS);
        setMarketplaceSuccessCreated(true);
      },
      onFailure: () => {
        showNotification(
          'Error al autenticar la cuenta. Por favor, contactate con soporte.',
          NOTIFICATION_VARIANT.ERROR
        );
      },
      showNotification,
    });

    setIsLoading(false);
  };

  const handleInputChange = (e) => {
    setAccountId(e.target.value);
  };

  return {
    handleMarketplaceOauth,
    isLoading,
    handleInputChange,
    isUserLogged,
    userIsAdmin,
    accountId,
    code,
    marketplaceSuccessCreated,
  };
};
